var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radiolist"},_vm._l((_vm.options),function(option,index){return _c('div',{key:option.value,staticClass:"radiolist-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],class:{
        'radiolist-item__radiobutton': true,
        'radiolist-item__radiobutton--selected': option.value === _vm.value,
        'radiolist-item__radiobutton--disabled': !option.enabled,
      },attrs:{"type":"radio","id":(_vm.id + "-" + index),"disabled":!option.enabled},domProps:{"value":option.value,"checked":_vm._q(_vm.selected,option.value)},on:{"change":function($event){_vm.selected=option.value}}}),_vm._v(" "),_c('label',{class:{
      'radiolist-item__label': true,
      'radiolist-item__label--selected': option.value === _vm.value,
      'radiolist-item__label--disabled': !option.enabled,
    },attrs:{"for":(_vm.id + "-" + index)},domProps:{"innerHTML":_vm._s(option.name)},on:{"click":function($event){return _vm.$emit('input', option.value)}}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdeac25","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioList.vue
// module id = 773
// module chunks = 1